import React from 'react';
import {Box, Stack, Typography} from '@mui/material';
import SendMessageButton from '../../SendMessageButton';
import UserAvatar from '../../UserAvatar';
import {useSession} from '../../../firebase/UserProvider';
import {auth} from '../../../firebase/config';

/**
 * Shared user mention info content used by both popover and floating menu node-info mode.
 */
export default function UserMentionInfoCard({userData, onMessageOpened = null, sx = {}}) {
    const {user: sessionUser} = useSession() || {};
    const authedUser = sessionUser || auth.currentUser || null;
    if (!userData) return null;

    const {id, uid, name, email, position, headshot} = userData;
    const mentionUid = uid || id || null;
    const authedUserId = authedUser?.uid || authedUser?.id || null;
    const isSelfMention = Boolean(mentionUid && authedUserId && String(mentionUid) === String(authedUserId));

    return (
        <Box sx={{p: 2, minWidth: 280, maxWidth: 360, ...sx}}>
            <Stack spacing={2}>
                <Stack direction="row" spacing={2} alignItems="center">
                    <UserAvatar
                        user={{
                            id: mentionUid,
                            uid: mentionUid,
                            displayName: name,
                            email,
                            headshot,
                            profilePicture: headshot,
                        }}
                        userId={mentionUid}
                        sx={{width: 56, height: 56}}
                    />
                    <Box sx={{flex: 1, minWidth: 0}}>
                        <Typography variant="h6" sx={{fontWeight: 600}}>
                            {name || 'Unknown User'}
                        </Typography>
                        {position && (
                            <Typography variant="body2" color="text.secondary">
                                {position.charAt(0).toUpperCase() + position.slice(1)}
                            </Typography>
                        )}
                        {email && (
                            <Typography
                                variant="body2"
                                sx={{
                                    wordBreak: 'break-all',
                                    color: 'primary.main',
                                }}
                            >
                                {email}
                            </Typography>
                        )}
                    </Box>
                </Stack>

                {mentionUid && !isSelfMention && (
                    <Box sx={{pt: 1}}>
                        <SendMessageButton
                            user={{
                                uid: mentionUid,
                                displayName: name,
                                email,
                                headshot,
                            }}
                            size="small"
                            variant="contained"
                            fullWidth
                            onOpened={onMessageOpened || undefined}
                        >
                            Send Message
                        </SendMessageButton>
                    </Box>
                )}

                {isSelfMention && (
                    <Typography variant="caption" color="text.secondary">
                        This mention points to your account.
                    </Typography>
                )}
            </Stack>
        </Box>
    );
}

